const FaqPage = () => {
  return (
    <h1>FAQ</h1>
  )
}

export default FaqPage;